import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

import InsuranceIssuerSelect from './InsuranceIssuerSelect';

export const PROVIDER_INSURANCE_COVERAGE_QUERY = gql`
  query InsuranceIssuerSelectProviderInsuranceCoverageData(
    $providerId: ID!
    $insuranceIssuerId: ID!
  ) {
    providerInsuranceCoverage(providerId: $providerId, insuranceIssuerId: $insuranceIssuerId) {
      status
      message
    }
  }
`;

const InsuranceIssuerSelectWithData = graphql(PROVIDER_INSURANCE_COVERAGE_QUERY, {
  name: 'providerInsuranceCoverageData',
  alias: 'withProviderInsuranceCoverageData',
  skip: ({ providerId, selectedItem }) => providerId == null || selectedItem == null,
  options({ providerId, selectedItem }) {
    return {
      variables: {
        providerId,
        insuranceIssuerId: selectedItem && selectedItem.id,
      },
      ssr: false,
    };
  },
})(InsuranceIssuerSelect);

InsuranceIssuerSelectWithData.propTypes = {
  providerId: PropTypes.string,
  selectedItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
};

export default InsuranceIssuerSelectWithData;
